import {inject, Injectable} from '@angular/core';
import {FilesService} from "../../../../services/files.service";
import {FilesStatus, GetFilesStatusParams} from "../../../../types/files-status.types";
import {
  advertisementInitialStatisticsResourceType,
  defaultAdvertisementInitialStatisticsFilesStatus
} from "../configs/advertisement-initial-statistics-modal-config";

@Injectable({
  providedIn: 'root'
})
export class AdvertisementInitialStatisticsModalService {
  private filesService: FilesService = inject(FilesService);

  public async getFilesStatus(id: number): Promise<FilesStatus> {
    const getFilesStatusParams: GetFilesStatusParams = {
      id: id,
      path: advertisementInitialStatisticsResourceType.path
    };

    return await this.filesService.fetchFilesStatus(getFilesStatusParams).catch(() => defaultAdvertisementInitialStatisticsFilesStatus);
  }
}
